import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconClock = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.99301 1.33398C4.31301 1.33398 1.33301 4.32065 1.33301 8.00065C1.33301 11.6807 4.31301 14.6673 7.99301 14.6673C11.6797 14.6673 14.6663 11.6807 14.6663 8.00065C14.6663 4.32065 11.6797 1.33398 7.99301 1.33398ZM7.99967 13.334C5.05301 13.334 2.66634 10.9473 2.66634 8.00065C2.66634 5.05398 5.05301 2.66732 7.99967 2.66732C10.9463 2.66732 13.333 5.05398 13.333 8.00065C13.333 10.9473 10.9463 13.334 7.99967 13.334ZM8.33301 4.66732H7.19967V8.66732L10.833 10.7673L11.3663 9.80065L8.33301 8.03398V4.66732Z",
		fill: "#5C5C5C"
	})
});
export default SvgIconClock;
